exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.infoMessage[data-v-29186896]{       \n    text-align: center;\n}\n@media screen and (max-width: 981px) {\n.infoMessage[data-v-29186896] {\n         font-size: 3em;\n}\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-29186896","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/misc/InfoMessage.vue
// module id = 75
// module chunks = 0